import { render } from "./Appearence.vue?vue&type=template&id=0b274dee"
import script from "./Appearence.vue?vue&type=script&lang=js"
export * from "./Appearence.vue?vue&type=script&lang=js"
script.render = render

export default script